// Infinite marquee strip. variant: "orange" | "light"
export default function Marquee({
    items,
    variant = "orange",
    speed = "",
    sep = "✳",
}) {
    const isOrange = variant === "orange";
    // duplicate enough times for a seamless infinite loop
    const loop = [...items, ...items, ...items, ...items];
    return (
        <div
            data-testid="marquee"
            className={`overflow-hidden py-5 ${
                isOrange
                    ? "bg-brand text-white"
                    : "bg-white text-ink border-y border-black/5"
            }`}
        >
            <div className={`flex w-max animate-marquee ${speed}`}>
                {loop.map((it, i) => (
                    <div key={i} className="flex items-center">
                        <span className="px-6 text-lg sm:text-xl font-extrabold uppercase tracking-wide whitespace-nowrap">
                            {it}
                        </span>
                        <span
                            className={`text-lg ${isOrange ? "text-white/80" : "text-brand"}`}
                        >
                            {sep}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
